import Component from '@glimmer/component'
import IntlService from 'ember-intl/services/intl'
import { t } from 'ember-intl'
import { not } from 'ember-truth-helpers'
import { context } from 'customer-flows/utils/core'
import { service } from '@ember/service'
import markdownit from 'markdown-it'

type TicketPickerArgs = {
  Args: {
    loading: boolean
    disabled?: boolean
    available: boolean
    name: string
    description?: string
    images: string[]
    hasError: boolean
    priceTagText: string | null
    count: number
    max: number
    min: number
    plusTooltip: string
    minusTooltip: string
    countIncremented: () => void
    countDecremented: () => void
    isMultiTicket?: boolean
    onMultiTicketClick?: () => void
    alwaysShowCount?: boolean
  }
  Blocks: {
    after: []
  }
}

export default class TicketPicker extends Component<TicketPickerArgs> {
  @service intl: IntlService
  @context('program/booking-flow') overrideSoldOutText: string

  md = markdownit()

  get showPlusMinusInput() {
    return this.args.available || this.args.count > 0
  }

  get soldOutText() {
    return this.overrideSoldOutText ?? this.intl.t('common.sold-out')
  }

  get markdownDescription() {
    if (!this.args.description || this.args.description === '') return ''
    return this.md.render(this.args.description)
  }

  <template>
    <il-product-card
      name={{@name}}
      variant='small'
      description={{this.markdownDescription}}
      {{! @glint-ignore: wait until we can't declare custom elements in glint }}
      images={{@images}}
      has-error={{@hasError}}
      disabled={{not @available}}
    >
      {{#if @priceTagText}}
        <il-price-tag slot='footer-left'>{{@priceTagText}}</il-price-tag>
      {{/if}}

      {{#if @loading}}
        <il-loader slot='footer-right' />
      {{else if @isMultiTicket}}
        <il-dropdown-trigger-button
          slot='footer-right'
          count={{@count}}
          {{! @glint-ignore: wait until we can't declare custom elements in glint }}
          onClick={{@onMultiTicketClick}}
        />
      {{else if this.showPlusMinusInput}}
        <il-plus-minus-input
          slot='footer-right'
          disabled={{@disabled}}
          always-show-count={{@alwaysShowCount}}
          count={{@count}}
          max={{@max}}
          min={{@min}}
          plus-tooltip={{@plusTooltip}}
          minus-tooltip={{@minusTooltip}}
          show-more-text={{t "common.show-more"}}
          show-less-text={{t "common.show-less"}}
          {{! @glint-ignore: wait until we can't declare custom elements in glint }}
          countIncremented={{@countIncremented}}
          {{! @glint-ignore: wait until we can't declare custom elements in glint }}
          countDecremented={{@countDecremented}}
        />
      {{else}}
        <div
          slot='footer-right'
          class='bg-neutrals-50 rounded-1.5 border-neutrals-100 text-component-bold-para-14 max-h-10.5 max-w-10.5 border px-1.5 text-center'
          data-testid='ticket-picker__unavailable-tag'
        >
          {{this.soldOutText}}
        </div>
      {{/if}}

      <div slot='after' class='text-component-reg-para-14 text-neutrals-300'>
        {{yield to='after'}}
      </div>
    </il-product-card>
  </template>
}
